// extracted by mini-css-extract-plugin
export default {"calendar-icon":"CalendarIcon_calendar-icon__kAnO2","title":"CalendarIcon_title__VyQKX","red":"CalendarIcon_red__FQhkG"};